import type { SpecialContributor } from './types'
import { roadDiagnosticsContributor } from './contributors/roadDiagnostics'
import { landLotsContributor } from './contributors/landLots'
import { roadAccidentsContributor } from './contributors/roadAccidents'
import { signRoadImageContributor } from './contributors/signRoadImage'

export const SPECIALS_REGISTRY: SpecialContributor[] = [
    roadDiagnosticsContributor,
    landLotsContributor,
    roadAccidentsContributor,
    signRoadImageContributor,
]


